import React, { useState, useContext, useEffect } from "react";
import './officeTiming.css';
import strings from "../../utils/property-file/officeTiming.json";
import Ripple from "../button/ripple";
import InputTimeBtn from "../button/inputTimeBtn";
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import constants from "../../utils/constants";
import { useForm } from "react-hook-form";
import CongratulationsPage from "../congratulationsPage/congratulationsPage";
import { FormContext } from "../formContext";
import { AdminFormContext } from "../adminFormContext";
import { ImageContext } from "../adminProfilePhotoContext";
import Geocode from "react-geocode";
import { OfficeFormContext } from "../officeFormContext";
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";
import {CompanyLogoContext} from "../companyLogoContext";

export default function OfficeTiming() {

    const {
        handleSubmit
    } = useForm();
    useEffect(() => {
        if (!location.state) {
            nav(constants.navigationLink.loginLink);
        }
    }, []);

    const [addingCompany ,setAddingCompany] = useState(false);
    const location = useLocation();
    const nav = useNavigate();
    const { formData, address } = useContext(FormContext);
    const { adminFormData } = useContext(AdminFormContext);
    const { imageData } = useContext(ImageContext);
    const { companyLogo } = useContext(CompanyLogoContext);
    const { officeFormData } = useContext(OfficeFormContext);
    const [flexibleToggle, setFlexibleToggle] = useState(true)
    const [onSuccess, setOnSuccess] = useState(false);
    const [flexTime, setFlexTime] = useState("");
 
    function validation() {
        let count = 0;
        if (Object.keys(officeFormData).length !== 0) {
            Object.entries(officeFormData).forEach(([ value]) => {
                if (value.startTime > value.endTime || value.lateTime > value.endTime || value.lateTime < value.startTime) {
                    count++;
                }
            });
            if (count > 0) {
                return;
            }
            else {
                companyRegSubmission(formData, address)
            }
        } else {
            toast.error(strings.validationError, { toastId: 'emptyTimeError' });
        }
    }

    async function getLatLngFromAddress(address) {
        try {
            if (address) {
                Geocode.setApiKey(constants.apiName.apiKey);
                let lat;
                let lng;
                const response = await Geocode.fromAddress(address)
                if (response) {
                    lat = response.results[0].geometry.location.lat;
                    lng = response.results[0].geometry.location.lng;
                    return { lat, lng }
                } else {
                    return false;
                }
            }
        } catch (e) {
            return false
        }
    }
  
    const companyRegSubmission = async (formData, address) => {
        setAddingCompany(true);
        let { lat, lng } = await getLatLngFromAddress(address);
        if (!lat || !lng) {
            lat = '';
            lng = '';
        }
        localStorage.setItem('companyName', formData.name);
        let body = {
            name: formData.data.name,
            email: formData.data.email,
            companyType: formData.data.companyType,
            address: address,
            companySize: formData.data.companySize,
            latitude: String(lat),
            longitude: String(lng)
        };
        let response = await api.companyProfile(body);
        if(response)
        {
        if (response.success) {
            localStorage.setItem('newSession', response.data.sessionKey)
            localStorage.setItem('companyName', formData.data.name)
            const data= JSON.parse(response.data);
            await companyLogoUpload(formData, companyLogo)
            adminProfileSubmission(adminFormData, imageData ,data.companyInfo._id,data.sessionKey)
            
        }
        else if(!response.success)
        {
            const data =JSON.parse(response.data)
            toast.error(data.body, { toastId: '001' })
            setAddingCompany(false);
        }
        else {
            setAddingCompany(false);
            toast.error(response.message, { toastId: 'error9' });
        }
    }
    else{
        setAddingCompany(false);
    }
    }

    const adminProfileSubmission = async (adminFormData, imageData ,companyId ) => {
        try {
            let body = {
            Id : companyId,
            name : adminFormData.data.adminName,
            email: adminFormData.data.email,
            empId: adminFormData.data.adminEmpId,
            empType: strings.admin,
            gender : adminFormData.data.adminGender,
            designation: adminFormData.data.adminDes,
            department: adminFormData.data.adminDept,
            dateOfJoining: adminFormData.data.adminJoiningDate,
            location: adminFormData.data.adminLoc,
            contact: adminFormData.data.adminCon,
            dateOfBirth: adminFormData.data.adminDob,
            nationality: adminFormData.data.adminNat,
            maritalStatus: adminFormData.data.maritalStatus,
            fathersName: adminFormData.data.adminFath,
            physicallyChallenged: adminFormData.data.physically,
            internationalEmployee: adminFormData.data.internationalEmployee,
            bloodGroup: adminFormData.data.bloodGroup,
            employmentType : adminFormData.data.employment
            }
            let response = await api.adminProfileRegistration(body);
            if(response)
            {
            if (response.success) {
                adminProfileUpload(adminFormData ,imageData)
                officeFormSubmission(companyId)
            }
            else {
                toast.error(response.response.data.message, { toastId: 'error1' });
            }
        }
        } catch (e) {
            toast.error(strings.error_message, { toastId: "error2" })
        }
    }

    const adminProfileUpload = async (adminFormData, selectedImage) => {
        try {
          if (selectedImage) {
            const formData = new FormData();
            formData.append("files", selectedImage);
            formData.append("email", adminFormData.data.email);
            const response = await api.adminProfileUpload(formData);
            if (response) {
              return response;
            }
          } else {
            return false;
          }
        } catch (e) {
          return e;
        }
      };


     const companyLogoUpload = async (companyData, companyLogo) => {
            
        
        try {
          if (companyLogo) {
            const formData = new FormData();
            formData.append("email", companyData.data.email );
            formData.append("files", companyLogo);
            
            const response = await api.companyLogo(formData);
            if (response) {
              return response;
            }
          } else {
            return false;
          }
        } catch (e) {
          return e;
        }
      };

    const officeFormSubmission = async (session) => {  
        try {
            const arr = Object.values(officeFormData);
            const id="Id";
            const newFieldValue=session;
            for (let i = 0; i < arr.length; i++) {
                arr[i][id] = newFieldValue;
            }
            const flexT="flexibleTiming";
            const flexTimeValue=(flexTime? flexTime : "");
            for (let i = 0; i < arr.length; i++) {
                arr[i][flexT] = flexTimeValue;
            }
            let response = await api.officeTiming(arr);
            
            if (response.data.success) {
                toast.success(strings.statusSuccess, { toastId: 'success03' })
                setAddingCompany(false);
                setOnSuccess(true);
            }
            else {
                const data =JSON.parse(response.data)
                toast.error(data.body, { toastId: '001' })
                setOnSuccess(false);
            }
        }
        catch (error) {
            return error;
        }
    }

    function inputTimeValidation(value, setTime) {
        let array = value.split(":");
        if (parseInt(array[0]) > 24) {
            setTime("");
            return;
        } else {
            setTime(value);
        }
        if (parseInt(array[1]) > 60) {
            setFlexTime("");
            return;
        } else {
            setTime(value);
        }
    }
    
    return (
        <>
            {onSuccess ? (
                <CongratulationsPage />
            ) : (
                <div>
                    <div className="side-arrow"
                        onClick={() => {
                            nav(constants.navigationLink.adminProfileLink, { state: true });
                        }}>
                        <i className="ri-arrow-left-line admin-side-arrow"></i>
                    </div>
                    <div className="parent-admin-container">
                        <div className="admin-progress">
                            <div className="office-progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                        <div className="child-admin-container mx-auto">
                            <div className="office-logo-container">
                                <i className="ri-time-line"></i>
                            </div>
                            <div className="company-page-heading">
                                <h4 className="mt-5">
                                    {strings.officeTimingHeading}
                                </h4>
                                <p>{strings.officePageDesc}
                                    <strong> {strings.step3}</strong></p>
                            </div>
                            <div className="grand-child-form">
                                <form onSubmit={handleSubmit(validation)}>
                                    <div className="mt-4">
                                        <div className="label-div mb-2">
                                            <label>{strings.days}</label>
                                            <label>{strings.from}</label>
                                            <label>{strings.to}</label>
                                            <label>{strings.late}</label>
                                        </div>
                                    </div>
                                    <div className="time-input">
                                        {strings.day.map((key, index) => {
                                            return (
                                                <div key={index}>
                                                    <InputTimeBtn name={key} index={index} />
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <div className="toggle-container ">
                                        <label className="office-toggle-label">{strings.flexWorkHrs}</label>
                                        <div className="checkbox-wrapper-3">
                                            <input type="checkbox" id="cbx-3" onClick={() => { setFlexibleToggle(!flexibleToggle) }} />
                                            <label htmlFor="cbx-3" className="toggle"><span></span></label>
                                        </div>
                                    </div>
                                    <div className={flexibleToggle ? "not-active mt-3" : "on-toggle-show  mt-3"}>
                                        <label htmlFor="">{strings.statement}</label>
                                        <InputMask
                                            className="timing-input active"
                                            mask="99:99"
                                            placeholder="HH:MM"
                                            value={flexTime}
                                            onChange={(e) => inputTimeValidation(e.target.value, setFlexTime)}
                                            required="required"
                                            disabled={flexibleToggle ? "disable" : ""}
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary next-btn" disabled={addingCompany}>
                                        {addingCompany ? <SpinnerButtonMedium/> : strings.loginBtn}
                                        <Ripple duration={1000} />
                                    </button>
                                </form>
                            </div>
                        </div >
                    </div >
                </div>
            )}
        </>
    );
}
